import { render, staticRenderFns } from "./wv-quarterly-insights.vue?vue&type=template&id=79240101&scoped=true&"
import script from "./wv-quarterly-insights.vue?vue&type=script&lang=js&"
export * from "./wv-quarterly-insights.vue?vue&type=script&lang=js&"
import style0 from "./wv-quarterly-insights.vue?vue&type=style&index=0&id=79240101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79240101",
  null
  
)

export default component.exports